var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/promise-native-constructor.js
// module id = 185
// module chunks = 0